import React, { useEffect } from 'react'

import { observer } from 'mobx-react'

import { Link } from 'retailer/components/atoms'
import { List, RetailerSubscriptionBox } from 'retailer/components/molecules'
import { useStores } from 'retailer/stores/hooks'

import style from './Footer.module.scss'

const Footer = () => {
  const { mainMenuStore, appConfigStore: { urls } } = useStores()

  useEffect(() => {
    if (!mainMenuStore.retailerSubscription) {
      mainMenuStore.fetchRetailerSubscription()
    }
  }, [mainMenuStore, mainMenuStore.retailerSubscription])

  return (
    <div className={style.Footer}>
      <RetailerSubscriptionBox
        subscription={mainMenuStore.retailerSubscription}
      />
      <List>
        <Link href={urls.blog} absolute block inverted>
          Blog
        </Link>
        <Link href={urls.terms} absolute block inverted>
          Terms of Service
        </Link>
        <Link href={urls.privacyPolicy} absolute block inverted>
          Privacy Policy
        </Link>
        <Link href={urls.contact} absolute block inverted>
          Contact
        </Link>
      </List>
    </div>
  )
}

export default observer(Footer)
